<template>
  <div id='myprofile'>
       <NavTop title='个人信息'/>
       <van-cell-group inset>
       <van-cell title="个人头像" is-link>
            <template>
               <van-uploader :after-read="afterRead" :upload-icon="headimg" :preview-image='false' image-fit="cover"/>
            </template>
       </van-cell>
       <van-cell title="会员名" :value="username"/>
       <van-cell title="姓名" :value="realname" v-if='realname!=null && realname!=""'/><van-cell title="姓名" is-link @click="showDiag('realname')" v-else/>
       <van-cell title="手机号" :value="mobile" />
     </van-cell-group>
     <van-dialog v-model="showRealname" title="设置姓名" show-cancel-button  :beforeClose="saveData">
          <van-cell-group>
               <van-field v-model="realname" label="姓名" placeholder="请输入姓名" />
          </van-cell-group>
     </van-dialog>
  </div>
</template>
<script>
import {Cell, CellGroup,Dialog,Field ,RadioGroup, Radio,DatetimePicker,Icon,Uploader  } from 'vant'
import NavTop from '@/components/navtop'

export default {
   name: 'myprofile',
   data() {
        return {
           headimg:'',  
           showRealname:false,  
           realname:'',
     
           mobile:'',
           username:'',

           keywords:'',
           value:'',
           currentDate:new Date(1980, 0, 1),
           minDate: new Date(1940, 0, 1),
           maxDate: new Date(2020, 0, 1)
        };
   }, 
   created(){
        this.getList(); 
   },
   methods: {
      getList(){    
          this.$post("/user/getUserInfo",{}).then((data)=>{
               if(!data.result.success){
                    this.$toast(data.result.info)
                    return false
               }
               this.headimg=data.result.info.headimg
               this.username=data.result.info.username
               this.realname=data.result.info.realname
               this.mobile=data.result.info.mobile
          })
      },
      showDiag(keywords){
          this.keywords=keywords
          if(keywords=="realname"){
               this.showRealname=true
          }
      },
      saveData(action,done){
          if(action=='cancel'){
               this.clearData()
               done()
               return false
          }
          var value=''
          if(this.keywords=='realname'){
              value=this.realname
          }
          if(value==null || value==''){
               this.$toast("请先输入信息");
               done(false);
               return false
          }

          this.value=value
          if(this.keywords==null || this.keywords==""){
               this.$toast("请先输入信息");return false;
          }
          this.$post("/user/saveUserInfo",{keywords:this.keywords,value:this.value}).then((data)=>{
               if(!data.result.success){
                    this.$toast(data.result.info);
                    this.clearData()
                    return false;
               }
               this.$toast(data.result.info)
               this.clearData()
               this.getList()
               done()
          })
         
      },
      clearData(){
         this.realname=null
      },
     afterRead(file) {  
      const uploadImgFile=file.content
      this.$post("/uploader/headImgBase64",{type:'headimg',image:uploadImgFile}).then((data)=>{
           if(data.result.success){
                this.$post("/user/saveHeadImg",{headimg:data.result.info.url}).then((saveData)=>{
                    this.$toast(saveData.result.info)
                    this.getList()
               })
           }
      })
    },
   },
   components: {
        [Cell.name]:Cell,
        [CellGroup.name]:CellGroup,
        [Dialog.Component.name]:Dialog.Component,
        [Field.name]:Field,
        [RadioGroup.name]:RadioGroup,
        [Radio.name]:Radio,
        [DatetimePicker.name]:DatetimePicker,
        [Icon.name]:Icon,
        [Uploader.name]:Uploader,
        NavTop
   }
}
</script>
<style scoped>
#myprofile{background-color:#F6F6F6;min-height: 100vh;}
::v-deep .van-cell__title{text-align: left;}
::v-deep .van-cell__value{text-align: right;}
.title-center{text-align: center!important;}
.title-right{text-align: right!important;}
::v-deep .van-cell-group--inset{margin:0 0.25rem;}
.content{padding: 0.3rem;display: flex;justify-content: center;align-items: center;}
::v-deep .van-cell{display: flex;align-items: center;}
::v-deep .van-uploader__upload{margin: 0;background-color: #fff;width:60px;height:60px;}
::v-deep .van-icon__image{width:1.5rem;height:1.5rem;border-radius: 50%;object-fit: cover;}
::v-deep .van-icon__image{width:1rem;height:1rem;}
</style>